/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetInsuranceInfoForEncounterErrorResponse,
  GetInsuranceInfoForEncounterResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getEncountersInsurance = (encounterId: number, signal?: AbortSignal) => {
  return api<GetInsuranceInfoForEncounterResponse | void>({
    url: `/api/encounters/${encounterId}/insurance`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersInsuranceQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/insurance`] as const;
};

export const getGetEncountersInsuranceQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersInsurance>>,
  TError = GetInsuranceInfoForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersInsurance>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersInsuranceQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersInsurance>>> = ({ signal }) =>
    getEncountersInsurance(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersInsurance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersInsuranceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersInsurance>>
>;
export type GetEncountersInsuranceQueryError = GetInsuranceInfoForEncounterErrorResponse;

export function useGetEncountersInsurance<
  TData = Awaited<ReturnType<typeof getEncountersInsurance>>,
  TError = GetInsuranceInfoForEncounterErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersInsurance>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersInsurance>>,
          TError,
          Awaited<ReturnType<typeof getEncountersInsurance>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersInsurance<
  TData = Awaited<ReturnType<typeof getEncountersInsurance>>,
  TError = GetInsuranceInfoForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersInsurance>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersInsurance>>,
          TError,
          Awaited<ReturnType<typeof getEncountersInsurance>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersInsurance<
  TData = Awaited<ReturnType<typeof getEncountersInsurance>>,
  TError = GetInsuranceInfoForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersInsurance>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersInsurance<
  TData = Awaited<ReturnType<typeof getEncountersInsurance>>,
  TError = GetInsuranceInfoForEncounterErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersInsurance>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersInsuranceQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
